import React, { Component } from 'react';
import axios from 'axios';
// import { decode } from 'html-entities';
import Moment from 'react-moment';
import 'moment-timezone';
import queryString from 'query-string';

// Components
import List from '../components/singlets/EventList';
import EventRegistrationSidebar from '../components/singlets/EventRegistration';
import VideoList from '../components/singlets/VideoList';
import { stripFileLinks } from '../utils/sanitizeHtml';

const REQUEST_TIMEOUT = 15000;

export class Event extends Component  {
  state = {
    isLoaded: false, hasError: false, eventInfo: [], categories: [{ name: '', _id: '00' }], similarEvents: [], similarEventsLoaded: false
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('#main').classList.remove('hero');

    const libcalAPI = process.env.REACT_APP_LIBCALAPI;
    let url = window.location.search;
    let params = queryString.parse(url);
    let eventId = params.eventid;

    const body = {
      'grant_type': 'client_credentials',
      'client_id': process.env.REACT_APP_CLIENTID,
      'client_secret': process.env.REACT_APP_CLIENTSECRET
    };

    axios.post(libcalAPI+'/oauth/token', body, { timeout: REQUEST_TIMEOUT })
    .then(res => {
      let token = res.data.access_token;

      return axios.get(libcalAPI+'/events/'+eventId, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        timeout: REQUEST_TIMEOUT
      })
      .then(res => {
        const event = res.data.events && res.data.events[0];
        if (!event) {
          throw new Error('Event not found: ' + eventId);
        }

        let terms = '';
        (event.category || []).forEach((c) => {
          let cat = {
            id: c.id,
            name: c.name
          }
          this.state.categories.push(cat);
          terms = terms + ',' + c.id;
        });

        this.setState({ eventInfo: event, isLoaded: true });

        const calId = process.env.REACT_APP_CALID;
        axios.get(libcalAPI+'/event_search?cal_id='+calId+'&search= &category='+terms.substring(1), {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          timeout: REQUEST_TIMEOUT
        })
        .then(res => {
          this.setState({ similarEvents: res.data.events, similarEventsLoaded: true });
        })
        .catch((error) => {
          console.dir(error);
          this.setState({ similarEvents: [], similarEventsLoaded: true });
        });
      });
    })
    .catch((error) => {
      console.dir(error);
      this.setState({ isLoaded: true, hasError: true });
    });
  }

  render() {
    const { eventInfo, categories, similarEvents, similarEventsLoaded, hasError } = this.state;
    // console.dir(eventInfo);

    if (hasError) {
      return (
        <div className="pageContent">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h1>Event Not Found</h1>
                <p className="breadcrumbs">
                  <i className="fas fa-chevron-double-left"></i><a href="/"> Back to iLearn Events</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="pageContent">
          <div className="container">
            <div className="event-detail">

              <div className="col-12">
                <h1>{ eventInfo.title }</h1>
                <p className="dateTime">
                  <Moment date={ eventInfo.start } format='dddd, MMMM DD, YYYY' /> - <Moment date={ eventInfo.start } format='hh:mm a z' tz='America/Los_Angeles' /> / <Moment date={ eventInfo.start } format='hh:mm a z' tz='America/Chicago' /> / <Moment date={ eventInfo.start } format='hh:mm a z' tz='America/New_York' />
                </p>
                <p className="breadcrumbs">
                  <i className="fas fa-chevron-double-left"></i><a href="/"> Back to iLearn Events</a>
                </p>
              </div>

              <div className="col-9 contentCont">
                <div className="eventBody">
                  {(eventInfo.featured_image !== "") && (
                    <img src={ eventInfo.featured_image } alt={ eventInfo.title } />
                  )}
                  <div className="description" dangerouslySetInnerHTML={{ __html: stripFileLinks(eventInfo.description) }} />

                  <div className="seats">
                    {eventInfo.presenter && (
                      <strong>
                        <i className="fa fa-user"></i> Presenter: { eventInfo.presenter }
                      </strong>
                    )}

                    {eventInfo.seats && (
                      <strong>
                        <i className="fa fa-users"></i> <span>{ eventInfo.seats - eventInfo.seats_taken }</span> of <span>{ eventInfo.seats }</span> seats available
                      </strong>
                    )}
                  </div>

                  <div className="categories">
                    <ul>
                      {categories.map((c, index) =>
                        <li key={ index }><a href={ '/category?catid=' + c.id  }>{ c.name }</a></li>
                        // <li key={ index }>{ c.name }</li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-3 sideCont">
                {similarEventsLoaded && (
                  <EventRegistrationSidebar event={ eventInfo } />
                )}
              </div>

            </div>
          </div>

          {similarEventsLoaded && (
            <div className="container similarEvents">
              <div className="row">
                <div className="col-9">
                  <h2>Similar Events</h2>
                  <List events={ similarEvents } limit="5" />
                </div>

                <div className="col-3 sideCont">
                  <VideoList count="6" />
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default Event;